
import { Component, Vue, Watch } from 'vue-property-decorator'
import { CollaboratorService } from "@/services/timetrack/CollaboratorService"
import Collaborator, { CollaborationState } from "@/types/collaborator/Collaborator"
import { ProjectService } from "@/services/timetrack/ProjectService"
import Project from "@/types/project/project"
import { TimesService } from "@/services/timetrack/TimesService"
import { ExpenditureService } from "@/services/timetrack/ExpenditureService"

@Component({
  filters: {
    formatCurrency (value: any) {
      return Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(value)
    }
  },
  components: {
  }
})
export default class CollaborationDeleteHandler extends Vue {
  private dialog = false
  private projects: Project[] = []
  private timeService = new TimesService()
  private projectService = new ProjectService()
  private expenditureService = new ExpenditureService()
  private collaboratorService = new CollaboratorService()

  @Watch('projects')
  private updateDialog () {
    if (this.projects.length > 0) {
      this.dialog = true
    }
  }

  created () {
    this.fetchDeletedCollaborations()
  }

  private fetchDeletedCollaborations () {
    this.collaboratorService.getProjectForCustomerByState(CollaborationState.delete)
      .then((collaborations) => {
        if (collaborations.length < 1) {
          this.$emit('projectCreated')
          this.dialog = false
          return
        }
        collaborations.map((collab) => {
          if (!collab || !collab.collaboratorProjectId) return
          this.projectService.getProject(collab.collaboratorProjectId)
            .then((project) => {
              if (project) {
                this.projects.push(project)
              }
            })
        })
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      })
  }

  private deleteProject (project: Project) {
    if (project && project.id) {
      this.timeService.deleteTrackedTimesForProject(project.id)
        .then(() => {
          this.removeExpenditures(project)
          if (project.id) {
            this.projectService.deleteProject(project.id)
              .then(() => {
                if (!project.id) return
                this.collaboratorService.getCollaboratorFromCollaboratorProject(project.id)
                  .then((collaboratorId) => {
                    if (!collaboratorId) return
                    this.collaboratorService.removeCollaboratorFromProject(collaboratorId)
                      .then(() => {
                        this.$emit('projectCreated')
                        this.fetchDeletedCollaborations()
                      })
                  })
              })
          }
        })
        .catch((error) => {
          this.$store.dispatch('error/setError', error)
        })
    }
  }

  private keepProject (project: Project) {
    if (!project.id) return
    this.projectService.setProjectOwner(project.id, true)
      .then(() => {
        if (!project.id) return
        this.collaboratorService.getCollaboratorFromCollaboratorProject(project.id)
          .then((collaboratorId) => {
            if (!collaboratorId) return
            this.collaboratorService.removeCollaboratorFromProject(collaboratorId)
              .then(() => {
                this.$emit('projectCreated')
                this.fetchDeletedCollaborations()
              })
          })
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      })
  }

  private removeExpenditures (project: Project) {
    if (project.trackedTimes) {
      const trackingIds = project.trackedTimes.map((tracking) => { return tracking.id })
      if (trackingIds && trackingIds.length > 0) {
        this.expenditureService.removeExpendituresForTrackings(trackingIds as string[])
      }
    }
  }
}
